/**
 * Logger do WebSocket de pedidos.
 *
 * O caminho do WS emitia mais de 100 console.* — cerca de 10 por mensagem
 * recebida, alguns materializando a lista inteira de pedidos só para logar.
 * O Blink guarda os argumentos de console com referência forte (buffer por
 * frame, e sem limite prático com o DevTools aberto), então nada disso era
 * coletado pelo GC: era o principal responsável pela memória da aba crescer ao
 * longo do dia num painel que fica horas aberto.
 *
 * Diagnóstico continua disponível ligando VITE_DEBUG_MODE=true.
 */

const debugEnabled = import.meta.env.DEV || import.meta.env.VITE_DEBUG_MODE === 'true';

export const wsLog = {
  isEnabled: debugEnabled,

  /** Diagnóstico de fluxo. Silencioso em produção. */
  debug(...args: unknown[]): void {
    if (debugEnabled) console.log(...args);
  },

  /** Condição inesperada porém recuperável. Silenciosa em produção. */
  warn(...args: unknown[]): void {
    if (debugEnabled) console.warn(...args);
  },

  /** Falha real. Sempre registrada — é o que se investiga em produção. */
  error(...args: unknown[]): void {
    console.error(...args);
  },
};
